
<!-- // OFFICIAL STATEMENT -->
<div class="us-official">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-8 col-12 text-left official-notice">
        <img alt="US Flag" src="assets/images/flags/usFlag.png"/>
        {{'TOOLBAR.OFFICIAL_NOTICE' | translate}}
      </div>
      <div class="col-lg-6 col-md-6 col-sm-4 col-12 text-right language-menu">
        <div class="dropdown float-end">
          <b class="d-none d-lg-inline">{{'TOOLBAR.CHOOSE_LANGUAGE' | translate}}:&nbsp;&nbsp;</b>
          <button class="btn dropdown-toggle" type="button" id="languageMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            <img alt="U.S. U.K. Flag" src="{{flagSrc}}"> {{ currentLanguage }}
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="" aria-label="submenu">
            <li>
              <a id="enLink" href="javascript:void(0)" class="dropdown-item" (click)="setLanguage('en')" title="English (U.S./U.K.)">
                <img alt="U.S. U.K. Flag" src="assets/images/flags/usUkFlag.png">
                English (U.S./U.K.)
              </a>
            </li>
            <li>
              <a id="frLink" href="javascript:void(0)" class="dropdown-item" (click)="setLanguage('fr')" title="French">
                <img alt="French Flag" src="assets/images/flags/franceFlag.png">
                Français
              </a>
            </li>
            <li class="last">
              <a id="esLink" href="javascript:void(0)" class="dropdown-item" (click)="setLanguage('es')" title="Spanish">
                <img height="26" alt="Spanish Flag" src="assets/images/flags/mexicoFlag.png">
                Español
              </a>
            </li> 
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- // LOGOS + NAVBAR -->
<div class="container">

  <!-- // LOGOS -->
  <div class="header">
    <!-- // TRUSTED TRAVELER PROGRAMS LOGO -->
    <div class="logo-ttp-main">
      <!-- <img alt="DHS Logo" src="assets/images/logos/dhs-seal.png"> -->
      <div class="cbp">
        <a href="http://www.dhs.gov" target="_blank" rel="noopener noreferrer">
          <img alt="{{'IMAGE_ALT.DHS_SEAL' | translate}}" src="assets/images/logos/tsaprecheck-banner.png">
        </a>
        <!-- <a href="http://www.cbp.gov" target="_blank">U.S. Customs and<br/> Border Protection</a>  -->
      </div>
      <div class="ttp">
        <a tabindex="0" href="javascript:void(0)" (click)="gotoTTP()" (on-enter)="gotoTTP()">Trusted Traveler <br class="d-md-none">Programs</a>
      </div>

    </div>

  </div>

</div>
